var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c(
                "v-layout",
                { attrs: { "justify-space-between": "" } },
                [
                  _vm.showAddGroupButton
                    ? _c(
                        "v-flex",
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { dark: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.addGroupFunc.apply(null, arguments)
                                }
                              }
                            },
                            [
                              _c("v-icon", { attrs: { dark: "" } }, [
                                _vm._v("add")
                              ]),
                              _vm._v(_vm._s(_vm.$t("addGroup")))
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs8: "", md2: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          "append-icon": "filter_list",
                          label: _vm.$t("search"),
                          "single-line": "",
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.filter,
                          callback: function($$v) {
                            _vm.filter = $$v
                          },
                          expression: "filter"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.$attrs.isRealtime
                ? _c(
                    "v-layout",
                    { attrs: { "justify-start": "", "align-baseline": "" } },
                    [
                      _c("v-flex", { staticClass: "success--text caption" }, [
                        _c("span", { staticClass: "realtime-border px-1" }, [
                          _vm._v(_vm._s(_vm.$t("realTIME")))
                        ])
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "users"
                ? _c("v-data-table", {
                    ref: "offerTable",
                    staticClass: "elevation-2 myDense",
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.users,
                      search: _vm.filter,
                      loading: _vm.loading,
                      pagination: _vm.pagination,
                      "rows-per-page-items": _vm.rowPerPage
                    },
                    on: {
                      "update:pagination": function($event) {
                        _vm.pagination = $event
                      }
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "progress",
                          fn: function() {
                            return [
                              _c("v-progress-linear", {
                                attrs: { color: "blue", indeterminate: "" }
                              })
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "items",
                          fn: function(props) {
                            return [
                              _c("td", { staticClass: "text-xs-left" }, [
                                _vm._v(_vm._s(props.index + 1))
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-xs-left" }, [
                                _vm._v(_vm._s(props.item.name))
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-xs-left" }, [
                                _vm._v(_vm._s(props.item.status))
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticClass: "text-xs-left" },
                                [
                                  _c("v-layout", [
                                    _vm._v(
                                      _vm._s(_vm.$t("email")) +
                                        ": " +
                                        _vm._s(props.item.email)
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("v-layout", [
                                    _vm._v(
                                      _vm._s(_vm.$t("note")) +
                                        ": " +
                                        _vm._s(props.item.note)
                                    )
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-xs-left" }, [
                                _vm._v(_vm._s(props.item.balance))
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticClass: "text-xs-center" },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "" } },
                                    [
                                      _vm.secondFunc &&
                                      !props.item.requestKey &&
                                      props.item.status !== "unsubscribed"
                                        ? _c(
                                            "v-flex",
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "mx-0",
                                                  attrs: {
                                                    dark: "",
                                                    color: "primary",
                                                    flat: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.secondFunc(
                                                        props.item
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.secondActionText)
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      props.item.status === "unsubscribed"
                                        ? _c(
                                            "v-flex",
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "mx-0",
                                                  attrs: {
                                                    color: "red",
                                                    flat: "",
                                                    loading:
                                                      props.item.isRemoveLoading
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.removeUser(
                                                        props.item
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("remove"))
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      props.item.status === "pending"
                                        ? _c(
                                            "v-flex",
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "mx-0",
                                                  attrs: {
                                                    flat: "",
                                                    color: "primary",
                                                    loading:
                                                      props.item
                                                        .isAcceptLoading,
                                                    dark: !props.item
                                                      .isRejectLoading,
                                                    disabled:
                                                      props.item
                                                        .isRejectLoading,
                                                    id:
                                                      "member" +
                                                      (props.index + 1)
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.showSelectGroupDialog(
                                                        props.item
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("accept"))
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      props.item.status === "pending"
                                        ? _c(
                                            "v-flex",
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "mx-0",
                                                  attrs: {
                                                    color: "primary",
                                                    flat: "",
                                                    loading:
                                                      props.item
                                                        .isRejectLoading,
                                                    dark: !props.item
                                                      .isAcceptLoading,
                                                    disabled:
                                                      props.item.isAcceptLoading
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.rejectUser(
                                                        props.item
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("reject"))
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      props.item.status !== "unsubscribed"
                                        ? _c(
                                            "v-flex",
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "mx-0",
                                                  attrs: {
                                                    color: "primary",
                                                    flat: "",
                                                    loading:
                                                      _vm.unsubscribeLoadingMap[
                                                        props.index
                                                      ],
                                                    dark: !_vm
                                                      .unsubscribeLoadingMap[
                                                      props.index
                                                    ],
                                                    disabled:
                                                      _vm.unsubscribeLoadingMap[
                                                        props.index
                                                      ]
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.unsubscribeUser(
                                                        props
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("unsubscribe")
                                                    ) + "\n                "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      706972965
                    )
                  })
                : _c("v-data-table", {
                    staticClass: "elevation-2 myDense",
                    attrs: {
                      headers: _vm.headers2,
                      items: _vm.displayGroups,
                      search: _vm.filter,
                      loading: _vm.loading,
                      pagination: _vm.pagination,
                      "rows-per-page-items": _vm.rowPerPage
                    },
                    on: {
                      "update:pagination": function($event) {
                        _vm.pagination = $event
                      }
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "progress",
                        fn: function() {
                          return [
                            _c("v-progress-linear", {
                              attrs: { color: "blue", indeterminate: "" }
                            })
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "items",
                        fn: function(props) {
                          return [
                            _c("td", { staticClass: "subheading" }, [
                              _vm._v(_vm._s(props.item.name))
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "text-xs-left" },
                              _vm._l(props.item.members, function(member) {
                                return _c("v-chip", { key: member.uid }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(member.name) +
                                      "\n            "
                                  )
                                ])
                              }),
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "text-xs-center" },
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", lg3: "" } },
                                  [
                                    _vm.firstFunc
                                      ? _c(
                                          "v-flex",
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  dark: "",
                                                  color: "primary",
                                                  flat: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.firstFunc(
                                                      props.item
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.firstActionText)
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.secondFunc
                                      ? _c(
                                          "v-flex",
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  dark: "",
                                                  color: "primary",
                                                  flat: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.secondFunc(
                                                      props.item
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.secondActionText)
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.selectGroupDialog
        ? _c("MemberEdit", {
            attrs: {
              title: _vm.$t("editUser"),
              isUser: true,
              isEditGroup: false,
              isRequest: "",
              user: _vm.userInEdit
            },
            model: {
              value: _vm.selectGroupDialog,
              callback: function($$v) {
                _vm.selectGroupDialog = $$v
              },
              expression: "selectGroupDialog"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58d1c554", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58d1c554","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MemberTable.vue
// module id = null
// module chunks = 